import React, { forwardRef } from 'react';
const ArrowUpRight = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "M4.025 3.5V5H9.95L3.5 11.45l1.05 1.05L11 6.05v5.925h1.5V3.5H4.025Z", fill: "currentColor" }))));
ArrowUpRight.displayName = 'ArrowUpRight';
export default ArrowUpRight;
